import { apiFetch } from "@core/index";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiEndpoint } from "../utils/constants";
import { enqueueSnackbar } from "notistack";

export const useDeletePartner = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (config: { referrerID: string }) => {
      const response = await apiFetch<{ statusCode: number; message: string }>(
        `${apiEndpoint}/${config.referrerID}`,
        {
          method: "DELETE",
        },
      );
      return response;
    },
    onSuccess: (response) => {
      if (response.statusCode >= 400) {
        enqueueSnackbar(response.message, {
          variant: "error",
          autoHideDuration: 5000,
        });
      } else {
        enqueueSnackbar("Partner deleted successfully.", {
          variant: "success",
          autoHideDuration: 2000,
        });
        queryClient.invalidateQueries({ queryKey: ["partners"] });
      }
    },
    onError: (error: Error) => {
      enqueueSnackbar("Failed to delete partner. Error: " + error.message, {
        variant: "error",
        autoHideDuration: 5000,
        preventDuplicate: true,
      });
    },
  });
};
